module.exports = __webpack_public_path__ + "static/Princeps_Kovik-37fd42e5fa891f85530233d38179c77e.webp";